__turbopack_context__.v({
  "className": "qRACpG_className",
  "variable": "qRACpG_variable",
});
